/**
 * @file MapLibre для карт сайта. Отдельный ES-модуль: подключается в head только на страницах с картой
 * (shared/_maplibre_loader), контроллеры карт получают его через utils/maps.
 */
import * as maplibregl from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'

const ATTRIBUTION =
  '© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>'

const config = JSON.parse(
  document.querySelector('script[data-map-config]').dataset.mapConfig
)

maplibregl.setWorkerUrl(config.workerUrl)

function createMap(container, options) {
  const map = new maplibregl.Map({
    container,
    style: {
      version: 8,
      sources: {
        osm: {
          type: 'raster',
          tiles: [config.tilesUrl],
          tileSize: 256,
          maxzoom: 19,
          attribution: ATTRIBUTION
        }
      },
      layers: [{ id: 'osm', type: 'raster', source: 'osm' }]
    },
    locale: config.locale,
    maxZoom: 19,
    cooperativeGestures: true,
    dragRotate: false,
    touchPitch: false,
    ...options
  })

  map.touchZoomRotate.disableRotation()
  map.keyboard.disableRotation()

  return map
}

window.padelmeshMaps = { maplibregl, createMap }
document.dispatchEvent(new CustomEvent('maps:ready'))
